import { useMemo } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';

import Table from '../components/contacts/Table.jsx';
import { useContacts } from '../store/contacts/hooks.js';

function Contacts() {
  const location = useLocation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const {
    data: { contacts },
  } = useContacts();

  const selectedContact = contacts.find((contact) => contact.id === id);

  // Support deep links (e.g. from notification emails) that pass the filter via
  // query params, in addition to in-app navigation that passes router state.
  const filterFromParams = useMemo(() => {
    const type = searchParams.get('type');
    if (!type) return null;

    return {
      type,
      segmentId: searchParams.get('segmentId') ?? undefined,
      id: searchParams.get('id') ?? undefined,
    };
  }, [searchParams]);

  const filter = location.state ?? filterFromParams;

  return <Table filter={filter} selectedContact={selectedContact} />;
}

export default Contacts;
